import { createAsyncThunk } from '@reduxjs/toolkit'
import { WorkingStepsController } from 'controllers/WorkingStepsController'
import { WorkingStepDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from '../selectors/bomItemSelector'

export const applyWorkingStepToAllParentFilteredRows = createAsyncThunk<
  void,
  { bomItemId: string; workingStep: WorkingStepDto },
  { state: RootAppState }
>(
  'bom/applyWorkingStepToAllParentFilteredRows',
  async ({ bomItemId, workingStep }, thunkAPI) => {
    const bomItem = bomItemSelector(thunkAPI.getState(), bomItemId)

    try {
      if (bomItem.type === 'Row') {
        const parentBomItem = bomItemSelector(
          thunkAPI.getState(),
          bomItem.parentId
        )
        if (
          parentBomItem.type === 'Assembly' ||
          parentBomItem.type === 'MaterialHeader'
        ) {
          const workingStepsController = new WorkingStepsController()

          return await workingStepsController.CopyWorkingStepsToOtherParts(
            bomItemId,
            workingStep.primaryWorkingStep,
            parentBomItem.filteredPartTypeIds.filter((x) => x !== bomItemId)
          )
          // return await workingStepsController.SaveAdditionalWorkingSteps(
          //   projectId,
          //   parentBomItem.filteredPartTypeIds,
          //   [{ workingStep: workingStep, formData: undefined }]
          // )
        }
      } else {
        throw 'ApplyWorkingStepToAll needs a bomItem of type Row'
      }
    } catch (ex) {
      ShowException('project', ex)
      throw ex
    }
  }
)
